export default link => {
  const element = document.createElement("a");
  element.href = link;
  element.download = "export.csv";
  document.body.appendChild(element);
  element.click();
};
